import { Users } from "./user"
import { z } from "zod/v4"
import { PredefinedNicknameId } from "../id"
import { DocumentSnapshotLike } from "../firestore"
import { CreatedAt, UpdatedAt } from "./system"

export const PredefinedNicknameValue = z.object({
  value: z.string().max(Users.NAME_MAX_LENGTH).min(Users.NAME_MIN_LENGTH).describe("ニックネームの文字列"),
})

export type PredefinedNicknameValue = z.infer<typeof PredefinedNicknameValue>

export const PredefinedNicknameDocumentBody = z.intersection(
  PredefinedNicknameValue,
  z.object({
    created_at: CreatedAt,
    updated_at: UpdatedAt
  })
)

export type PredefinedNicknameDocumentBody = z.infer<typeof PredefinedNicknameDocumentBody>

export type PredefinedNicknameDocument = PredefinedNicknameDocumentBody & {
  id: PredefinedNicknameId,
}

export class PredefinedNicknames {
  static toDocumentData(predefinedNicknameDocument: PredefinedNicknameDocument): object {
    return {
      ...predefinedNicknameDocument,
      // id は document path に入るので入れない
      id: undefined,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): PredefinedNicknameDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: PredefinedNicknameId(doc.id),
      value: data["value"],
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }
}
